// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__BEV75","banner__image":"styles_banner__image__y4XRn","pulse":"styles_pulse__B3AJH","jump":"styles_jump__ZN0_K"};